export const LR_SEL_EXAMS = 'LR_SELECTED_EXAMS';
export const LR_SEL_CONTENTS = 'LR_SELECTED_CONTENTS';
export const LR_SEL_PANEL_CONTENTS = 'LR_SELECTED_PANEL_CONTENTS';
export const LR_PERSONAL_INFO = 'LR_PERSONAL_INFO';
export const LR_OTHER_INFO = 'LR_OTHER_INFO';
export const LR_SEARCHED_NAME = 'LR_SEARCHED_NAME';
export const LR_SEARCHED_ID = 'LR_SEARCHED_ID';
export const LR_STEP_PROGRESS = 'LR_STEP_PROGRESS';
export const LR_REQUEST_TYPE = 'LR_REQ_TYPE';
export const LR_IS_EXAM_UPDATED = 'LR_EXAM_UPDATED_WHILE_EDITTING';
export const LR_EDIT_SEL_EXAM_REF = 'LR_EDIT_SEL_EXAM_REF';
export const LR_DEL_SECTIONS = 'LR_DEL_SECTIONS';
export const LR_EDIT_QEXAMS = 'LR_EDIT_QEXAMS';